import React, { useState } from 'react';
import PropTypes from 'prop-types';
import ReactSwipe from 'react-swipe';

import SmartImage from 'dpl/components/SmartImage';
import PhotoAlbumBullets from 'dpl/components/PhotoAlbumBullets';

export default function MobileBuyerQuotesSlider({ items }) {
  const [currentIdx, setCurrentIdx] = useState(0);

  return (
    <div className="MobileBuyerQuotesSlider tc bg-near-white pv6">
      <div className="mb2">
        <ReactSwipe
          childCount={items.length}
          swipeOptions={{
            continuous: true,
            transitionEnd: idx => setCurrentIdx(idx)
          }}
        >
          {items.map((item, idx) => (
            <div key={idx}>
              <div className="mb4">
                <SmartImage
                  src={item.photoUrl}
                  className="br-100"
                  width="104px"
                  height="104px"
                  lazy
                />
              </div>
              <p className="mb2 ph8">{item.quote}</p>
              <p className="f2">&ndash;{item.name}</p>
            </div>
          ))}
        </ReactSwipe>
      </div>
      <div className="tc">
        <PhotoAlbumBullets
          imageCount={items.length}
          currentImageIdx={currentIdx}
          bulletStyle={{ color: 'black' }}
        />
      </div>
    </div>
  );
}

MobileBuyerQuotesSlider.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      photoUrl: PropTypes.string,
      quote: PropTypes.string,
      name: PropTypes.string
    })
  ).isRequired
};
